
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

interface RecipeCardProps {
  title: string;
  children: React.ReactNode;
  icon?: string;
}

export const RecipeCard = ({ title, children, icon }: RecipeCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="w-full"
    >
      <Card className="p-4 sm:p-6 md:p-8 backdrop-blur-sm bg-white/90 border border-primary/10 shadow-lg rounded-2xl hover:shadow-xl transition-all duration-300">
        <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
          {icon && <span className="text-xl sm:text-2xl">{icon}</span>}
          <h3 className="text-lg sm:text-xl font-semibold text-foreground">{title}</h3>
        </div>
        <div className="text-muted-foreground">{children}</div>
      </Card>
    </motion.div>
  );
};
